export enum EColorGradients {
  Sherbet = '--gradient-sherbet',
  Sherbet2 = '--gradient-sherbet-2',
  Sherbet3 = '--gradient-sherbet-3',
  Seabreeze = '--gradient-seabreeze',
  PinaColada = '--gradient-pina-colada',
  Sunset = '--gradient-sunset',
  SunsetLight = '--gradient-sunset-light',
  Sunrise = '--gradient-sunrise',
  SunriseLight = '--gradient-sunrise-light',
  Watermelon = '--gradient-watermelon',
  BlueRazz = '--gradient-blue-razz',
  BlueRazzLight = '--gradient-blue-razz-light',
  NoGradientAtAll = '--no-gradient',
}
